var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.isShowCreateWorkDialog,
            "close-on-press-escape": false,
            "close-on-click-modal": false,
            width: "750px",
            "before-close": _vm.handleClose,
            "append-to-body": _vm.appendToBody
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowCreateWorkDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "main" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "80px",
                    size: "small",
                    disabled: _vm.isNotEdit
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "作业标题", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", maxlength: "30" },
                        model: {
                          value: _vm.form.name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isNotEdit
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "作业内容", required: "" } },
                        [
                          _vm.isShowCreateWorkDialog
                            ? _c("v-editor", {
                                ref: "edit2",
                                staticClass: "discuss_content",
                                attrs: { onlyKey: _vm.onlyKey },
                                model: {
                                  value: _vm.form.content,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "content", $$v)
                                  },
                                  expression: "form.content"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-upload",
                            {
                              ref: "uploadFile",
                              staticClass: "upload-demo",
                              staticStyle: { "margin-top": "10px" },
                              attrs: {
                                action: _vm.importUrl,
                                "file-list": _vm.fileList2,
                                accept: "*.png",
                                limit: 10,
                                "on-progress": _vm.onProgress,
                                headers: _vm.headers,
                                "before-upload": _vm.beforeAvatarUpload,
                                "before-remove": _vm.beforeRemove,
                                "on-remove": _vm.handleRemove,
                                "on-success": _vm.handleAvatarSuccess,
                                "on-preview": _vm.handlePreview,
                                "on-error": _vm.onError,
                                "on-exceed": _vm.handleExceed,
                                multiple: ""
                              }
                            },
                            [
                              _c(
                                "el-button",
                                { attrs: { size: "small", type: "primary" } },
                                [_vm._v("添加附件")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isNotEdit
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "作业内容", required: "" } },
                        [
                          _c("div", {
                            staticClass: "previewBox editorShowArea ql-editor",
                            domProps: { innerHTML: _vm._s(_vm.form.content) }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "previewAttachment" },
                            _vm._l(_vm.form.fileList, function(item) {
                              return _c("span", { key: item.id }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.attachmentName) +
                                    "\n            "
                                )
                              ])
                            }),
                            0
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isNotEdit
            ? _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.handleClose }
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: !!_vm.isdisableds,
                        size: "small"
                      },
                      on: {
                        click: function($event) {
                          return _vm.submitFunc("form")
                        }
                      }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a59268d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a59268d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/teachingDetail/components/CreateWork.vue
// module id = null
// module chunks = 